import { motion } from "framer-motion";
import social from "@/assets/images/socialimpact.png";

export default function SocialImpact() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-emerald-500 to-teal-700 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Animated Image */}
          <motion.div
            className="flex justify-center lg:justify-start"
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.div
              className="w-full max-w-md rounded-2xl flex items-center justify-center overflow-hidden"
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <img
                src={social}
                alt="Social Impact"
                className="w-full h-full object-cover"
              />
            </motion.div>
          </motion.div>

          {/* Right side - Animated Content */}
          <motion.div
            className="space-y-6"
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight">
                Social Impact
              </h2>
              <div className="w-16 h-1.5 bg-white rounded-full"></div>
            </div>

            <p className="text-base sm:text-lg lg:text-xl text-white/90 leading-relaxed">
              Every order has the power to make a difference. While you enjoy
              delicious meals, groceries, and everyday essentials, choosing{" "}
              <span className="text-green-500 font-bold">
                Mystery Bags
              </span>{" "}
              helps rescue perfectly good surplus food, reduce waste, and create
              a more sustainable future for our communities.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
